import React from 'react'
import CommonNavbar from '../../Navbar/CommonNavbar'
import { useNavigate, useLocation } from "react-router-dom";
import { usePermissions } from '../../hooks/PermissionContext';
import AdditionalPermissionWrapper from '../../hooks/AdditionalPermissionWrapper';

const Invoice_header = ({ onSearch, disableSearch = false }) => {

    let ModuleId = 24
    const { getModulePermission } = usePermissions();
    const permission = getModulePermission(ModuleId);
    console.log("activeModuleId", ModuleId);

    console.log("permission", permission);

    const navigate = useNavigate();
    const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
  };
    return (
        <div>
            <header>
                <nav className="nav-items">
                    <ul className="nav-links">
                        <AdditionalPermissionWrapper permissionKey="sales_invoice" moduleId={ModuleId}>
                            <li className="list">
                                <button
                                    onClick={() => handleNavigation("/salesInvoice")}
                            className={`tabs ${location.pathname.startsWith("/sales") ? "active" : ""}`}
                                >
                                    Sales Invoice
                                </button>
                            </li>
                        </AdditionalPermissionWrapper>

                        <AdditionalPermissionWrapper permissionKey="cost_invoice" moduleId={ModuleId}>
                            <li className="list">
                                <button
                                    onClick={() => handleNavigation("/costInvoice")}
                            className={`tabs ${location.pathname.startsWith("/cost") ? "active" : ""}`}
                                >
                                    Cost Invoice
                                </button>
                            </li>
                        </AdditionalPermissionWrapper>
                    </ul>

                   <CommonNavbar onSearch={onSearch} disableSearch={disableSearch} />

                </nav>
            </header>
        </div>
    )
}

export default Invoice_header